import { Component } from '@angular/core';

@Component({
  selector: 'stars-anatomy-platforms',
  templateUrl: './anatomy-platforms.html',
  styleUrls: ['./anatomy-platforms.scss']
})
export class AnatomyPlatformsComponent {}
